import React, { useEffect, useState } from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/pathObj'
import { useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import ErrorMessage from 'components/ErrorMessage'
import { useTranslation } from 'react-i18next'
import OInputField from 'components/reusable/OInputField'
import { preventMaxInput } from 'utils/validations'
import formValidation from '../../utils/formValidation'
import { validateFile } from 'utils/reusableMethods'
import OImage from 'components/reusable/OImage'
import NoImage from '../../assets/images/noImage.jpg'

const CurrencyExchangeEdit = ({ setEditShowModal, itemUpdated, item }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const [isLoading, setIsLoading] = useState(false)

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true
  })


   useEffect(() => {
      reset(item)
    }, [])

  const onSubmit = async data => {
    try {
      const path = apiPath.updateCurrencyExchange
      const result = await apiPut(path, data)
      if (result.data.success) {
        itemUpdated()
        setEditShowModal(false)
        notification.success(result?.data.message)
      } else {
        notification.error(result?.data.message)
      }
    } catch (error) {
      console.log('error in get all users list==>>>>', error)
      notification.error(error.message)
    }
    setIsLoading(false)
  }

  const preventMaxTenThousand = e => {
    if (e.target.value > 10000) {
      e.target.value = e.target.value.slice(0, 1)
    }
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <div
              className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none lg:min-w-[1000px]'
              style={{ maxHeight: '80vh', overflowY: 'scroll' }}
            >
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('O_EDIT_USER')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setEditShowModal(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className='grid grid-cols-4'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0  w-full group'
                      name='market_bid_price'
                      disabled='disabled'
                      inputLabel={
                        <>
                          {t('CURRENCY_BID')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='number'
                      maxLength={15}
                      onInput={e => {
                        e.preventDefault()
                      }}
                      register={register(
                        'market_bid_price',{
                          required: {
                            value: true
                          },
                          min: {
                            value: 0.01,
                            message: t('MINIMUM_VALUE_MUST_BE_0.01')
                          },
                          max: {
                            value: 10000
                          },
                        }
                      )}
                      errors={errors}
                    />
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='market_ask_price'
                      inputLabel={
                        <>
                          {t('CURRENCY_ASK')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='number'
                      disabled={true}
                      maxLength={15}
                      onInput={e => {
                        e.preventDefault()
                      } }
                      register={register(
                        'market_ask_price',
                        {
                          required: {
                            value: true
                          },
                          min: {
                            value: 0.01,
                            message: t('MINIMUM_VALUE_MUST_BE_0.01')
                          },
                          max: {
                            value: 10000,
                          },
                        }
                      )}
                      errors={errors}
                    />
                  </div>
                   <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='company_bid_price'
                      inputLabel={
                        <>
                          {t('SYSTEM_CURRENCY_BID')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='number'
                      maxLength={15}
                      onInput={e => preventMaxTenThousand(e)}
                      register={register(
                        'company_bid_price', {
                          required: {
                            value: true
                          },
                          min: {
                            value: 0.01,
                            message: t('MINIMUM_VALUE_MUST_BE_0.01')
                          },
                          max: {
                            value: 10000,
                          },
                        }
                      )}
                      errors={errors}
                    />
                  </div>
                   <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='company_ask_price'
                      inputLabel={
                        <>
                          {t('SYSTEM_CURRENCY_ASK')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='number'
                      maxLength={15}
                      onInput={e => preventMaxTenThousand(e)}
                      register={register(
                        'company_ask_price',{
                          required: {
                            value: true
                          },
                          min: {
                            value: 0.01,
                            message: t('MINIMUM_VALUE_MUST_BE_0.01')
                          },
                          max: {
                            value: 10000,
                          },
                        }
                      )}
                      errors={errors}
                    />
                  </div>

                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setEditShowModal(false)}
                >
                  {t('O_BACK')}
                </button>

                {isLoading ? (
                  <div className='spinner-container bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'>
                    <div className='loading-spinner'></div>
                  </div>
                ) : (
                  <button
                    className='bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                    type='submit'
                    onClick={handleSubmit(onSubmit)}
                  >
                    {t('O_EDIT')}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default CurrencyExchangeEdit
